<template>
  <div>
    <div
      id="horizontal-navigation-hover-normal"
      class="d-lg-block mt-2 mt-lg-0"
    >
      <ul class="nav-main nav-main-horizontal nav-main-hover">
        <!-- Expert items -->
        <li class="nav-main-item">
          <a
            class="nav-main-link nav-main-link-submenu"
            data-toggle="submenu"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
          >
            <i class="nav-main-link-icon fa fa-users" />
            <span class="nav-main-link-name">Expert</span>
          </a>
          <ul class="nav-main-submenu">
            <li class="nav-main-item">
              <form
                ref="expertAssignmentInviteEmailForm"
                method="get"
                action="/admin/email/expert-assignment-invite/generate"
                class="expert-assignment-invite-mail"
                name="expertAssignmentInviteEmailForm"
              >
                <input
                  type="hidden"
                  name="_token"
                  :value="csrf"
                >
                <input
                  type="hidden"
                  name="selectedExpertIds"
                  :value="selectedExpertIdsComputed"
                >
                <input
                  type="hidden"
                  name="projectId"
                  :value="project.id"
                >
                <input
                  type="hidden"
                  name="emailType"
                  :value="emailType"
                >
              </form>
              <a
                v-if="routes['backend_dummy_expert_send_invitation_email']"
                id="expertAssignmentInviteInvitationLegacy"
                class="nav-main-link"
                href="#"
                @click.stop.prevent="expertAssignmentInviteInvitation('invite')"
              >
                <span class="nav-main-link-name">Send Invitation Email</span>
              </a>
              <a
                v-if="routes['backend_dummy_expert_send_lead_email']"
                id="expertAssignmentInviteLeadLegacy"
                class="nav-main-link"
                href=""
                @click.stop.prevent="expertAssignmentInviteInvitation('lead')"
              >
                <span class="nav-main-link-name">Send Lead Email</span>
              </a>
            </li>
            <li class="nav-main-item">
              <a
                class="nav-main-link"
                href=""
                @click.stop.prevent="deleteManyAssignments"
              >
                <span class="nav-main-link-name"> Remove Selected Experts </span>
              </a>
            </li>
            <li class="nav-main-item">
              <a
                class="nav-main-link"
                href="#"
                @click.stop.prevent="showProjectSelectModal"
              >
                <span class="nav-main-link-name">Migrate to other project</span>
              </a>
            </li>
          </ul>
        </li>

        <!-- Client items -->
        <li
          v-show="routes['backend_dummy_client_send_proposal_email']"
          class="nav-main-item"
        >
          <a
            class="nav-main-link nav-main-link-submenu"
            data-toggle="submenu"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
          >
            <i class="nav-main-link-icon far fa-user-circle" />
            <span class="nav-main-link-name">Client</span>
          </a>
          <ul class="nav-main-submenu">
            <li class="nav-main-item">
              <form
                ref="clientProposalGenerateEmailForm"
                method="get"
                action="/admin/email/client-proposal/generate"
                class="expert-assignment-invite-mail"
                name="clientProposalGenerateEmailForm"
              >
                <input
                  type="hidden"
                  name="_token"
                  :value="csrf"
                >
                <input
                  type="hidden"
                  name="selectedExpertIds"
                  :value="selectedExpertIdsComputed"
                >
                <input
                  type="hidden"
                  name="selectedJobExpIds"
                  :value="selectedJobExpIdsComputed"
                >
                <input
                  type="hidden"
                  name="projectId"
                  :value="project.id"
                >
              </form>
              <a
                id="clientProposalGenerateEmailAnchorLegacy"
                class="nav-main-link"
                href="#"
                @click.stop.prevent="clientProposalGenerateEmailAnchor"
              >
                <span class="nav-main-link-name">Send Proposal Email</span>
              </a>
            </li>
          </ul>
        </li>

        <!-- Clone Project items -->
        <li
          v-if="routes['backend_project_edit']"
          class="nav-main-item"
        >
          <a
            class="nav-main-link nav-main-link-submenu"
            data-toggle="submenu"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
          >
            <i class="nav-main-link-icon far fa-clone" />
            <span class="nav-main-link-name">Clone Project</span>
          </a>
          <ul class="nav-main-submenu">
            <li class="nav-main-item">
              <a
                class="nav-main-link"
                :href="getCloneProjectUrl(project.id, false)"
              >Clone Project</a>
              <a
                class="nav-main-link"
                :href="getCloneProjectUrl(project.id, true)"
                @click.stop.prevent="checkExpertChecked"
              >Clone project with checked experts</a>
            </li>
          </ul>
        </li>

        <li v-if="canExportInvoice" class="nav-main-item">
          <a class="nav-main-link" href="#" @click.stop.prevent="showInvoiceExportModal">
            <i class="nav-main-link-icon fa fa-file-invoice-dollar" />
            <span class="nav-main-link-name">Export Invoice</span>
          </a>
        </li>

        <li class="my-auto mx-2 pt-1">
          <div class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
            <input
              id="hideJobExperiences"
              type="checkbox"
              class="custom-control-input"
              @change.stop.prevent="$store.commit('expert/setHideJobExperiencesComputed', $event.target.checked)"
            >

            <label
              class="custom-control-label"
              for="hideJobExperiences"
            >{{
              $store.state.expert.hideJobExperiencesComputed
                ? "Show job experiences"
                : "Hide job experiences"
            }}</label>
          </div>
        </li>

        <li class="my-auto mx-2 pt-1">
          <div class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
            <input
              id="selectAllExperts"
              type="checkbox"
              class="custom-control-input"
              :checked="selectAllExperts"
              @change.stop.prevent="toggleSelectAllExperts"
            >
            <label
              class="custom-control-label"
              for="selectAllExperts"
            >{{
              $store.state.expert.selectAllExperts
                ? "Deselect all experts"
                : "Select all experts"
            }}</label>
          </div>
        </li>

        <li class="my-auto mx-3 pt-1">
          <b-dropdown
            split
            :text="assignmentStatusFilterSelected ? assignmentStatusFilterSelected.name : 'Sort experts by status'"
            :variant="assignmentStatusFilterSelected && statusStyles[assignmentStatusFilterSelected.name] ? statusStyles[assignmentStatusFilterSelected.name] : 'secondary'"
            size="sm"
          >
            <b-dropdown-item-button @click.stop.prevent="filterExpertByStatus(null)">
              Sort experts by status
            </b-dropdown-item-button>

            <b-dropdown-item-button
              v-for="(status, ib) in allAssignmentStatuses"
              :key="`filter${ib}`"
              @click.stop.prevent="filterExpertByStatus(status)"
            >
              {{ status.name }} ({{ status.count }})
            </b-dropdown-item-button>
          </b-dropdown>

          <b-spinner
            v-if="loader"
            variant="primary"
            small
            label="Loading..."
          />
        </li>

        <li class="my-auto mx-3 pt-1">
          <div class="custom-control custom-checkbox custom-control-lg mb-1 display-option">
            <button
              class="btn btn-sm btn-success"
              @click.stop.prevent="toggleAll"
            >
              {{
                $store.state.expert.showAll
                  ? "Show Paginated"
                  : "Show All"
              }}
            </button>
          </div>
        </li>
      </ul>
    </div>

    <!-- Project Select Modal Component -->
    <project-select-modal
      ref="projectSelectModal"
      :current-project-id="project.id"
      :selected-experts="selectedExpertsForModal"
      @remove-expert="onRemoveExpertFromModal"
      @migration-complete="onMigrationComplete"
      @closed="onProjectSelectModalClosed"
    />

    <invoice-export-modal
      v-if="project.id"
      ref="invoiceExportModal"
      :project-id="project.id"
    />

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { isEmpty } from "lodash";
import ProjectSelectModal from "./ProjectSelectModal.vue";
import InvoiceExportModal from "./InvoiceExportModal.vue";

export default {
    name: "ProjectNavBar",
    components: {
        ProjectSelectModal,
        InvoiceExportModal,
    },
    props: {
        projectInit: {
            type: String,
            required: true,
        },
        allAssignmentStatusesInit: {
            type: String,
            required: true,
        },
        isSuperAdmin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            csrf: "",
            projectRaw: {},
            emailType: "",
            allAssignmentStatuses: [],
            loader: false,
        };
    },
    computed: {
        project() {
            return this.projectRaw || {};
        },
        routes() {
            return this.$store.state.routes.routePermissions || [];
        },
        selectedExpertIdsComputed() {
            return this.$store.state.expert.selectedExpertIds.join(",");
        },
        selectedJobExpIdsComputed() {
            return this.$store.state.expert.selectedJobExpIds.join(",");
        },
        ...mapGetters({
            selectAllExperts: "expert/selectAllExperts",
            assignmentStatusFilterSelected: "expert/assignmentStatusFilterSelected",
            statusStyles: "project/statusStyles",
            selectedExpertIds: "expert/selectedExpertIds",
            isExpertUnsubscribed: "expert/isExpertUnsubscribed",
        }),
        selectedExpertsForModal() {
            const experts = [];
            const usersData = this.$store.state.expert.usersExpertsObj?.data || [];
            const selectedJobExpIds = this.$store.state.expert.selectedJobExpIds || [];

            this.selectedExpertIds.forEach((expertId) => {
                const userData = usersData.find((user) => Number(user.expert.id) === Number(expertId));
                if (!userData || !userData.expert) return;

                const assignment = (userData.expert.assignments || []).find(
                    (a) => Number(a.project_id) === Number(this.project.id)
                );
                const jobExps = assignment?.job_experiences || assignment?.jobExperiences || [];
                const assignmentJobExpIds = jobExps.map((je) => Number(je.id || je.job_experience_id));

                let jobExperienceIds = assignmentJobExpIds;
                if (selectedJobExpIds.length > 0) {
                    const selectedSet = new Set(selectedJobExpIds.map(Number));
                    jobExperienceIds = assignmentJobExpIds.filter((id) => selectedSet.has(id));
                }
                if (jobExperienceIds.length === 0) {
                    jobExperienceIds = assignmentJobExpIds;
                }
                if (jobExperienceIds.length === 0) return;

                experts.push({
                    id: userData.expert.id,
                    name: userData.full_name || userData.first_name + " " + userData.last_name || `Expert #${userData.expert.id}`,
                    email: userData.email || userData.email_2 || "",
                    jobExperienceIds,
                    isDnc: this.isExpertUnsubscribed(userData.expert.id),
                });
            });

            return experts;
        },
        canExportInvoice() {
            return this.isSuperAdmin;
        },
    },
    mounted() {
        this.projectRaw = this.projectInit ? JSON.parse(this.projectInit) : null;
        const token = document.head.querySelector("meta[name=\"csrf-token\"]");
        this.csrf = token.content;
        this.allAssignmentStatuses = this.allAssignmentStatusesInit.length > 0
            ? JSON.parse(this.allAssignmentStatusesInit)
            : [];
    },
    methods: {
        async deleteManyAssignments() {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }

            if (!confirm("Are you sure you want to remove these experts from the project?")) {
                return;
            }
            const selectedAssignmentIds = [];
            this.$store.state.expert.selectedExpertIds.forEach((sid) => {
                this.$store.state.expert.usersExpertsObj.data.forEach((user) => {
                    if (Number(user.expert.id) === Number(sid)) {
                        user.expert.assignments.forEach((assignment) => {
                            if (Number(assignment.project_id) === Number(this.project.id)) {
                                selectedAssignmentIds.push(assignment.id);
                            }
                        });
                    }
                });
            });
            const url = "/admin/assignment/deleteMany";
            try {
                const responce = await axios.post(url, {
                    selectedAssignmentIds: selectedAssignmentIds.join(","),
                });
                if (responce.data.errorAssignmentIds.length > 0) {
                    One.helpers(
                        "jq-notify",
                        {
                            type: "danger",
                            icon: "fa fa-times me-1",
                            message: `${responce.data.errorAssignmentIds.length} expert(s) could not be removed from this project. Please check their calendar, as they may have scheduled appointments. Or have payment requested`,
                        });
                }
                this.$store.commit("expert/setSelectedExpertIds", []);
                this.$store.commit("expert/setSelectedJobExpIds", []);

                await this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page: 1 });
            } catch (e) {
                One.helpers(
                    "jq-notify",
                    {
                        type: "danger",
                        icon: "fa fa-times me-1",
                        message: "An unknown error has occurred",
                    });
            }
        },
        checkExpertChecked(event) {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }

            window.location.href = event.target.href;
        },
        clientProposalGenerateEmailAnchor() {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }
            if (this.selectedJobExpIdsComputed.length === 0) {
                alert("You have not selected any job experience");
                return;
            }
            setTimeout(() => {
                this.$refs.clientProposalGenerateEmailForm.submit();
            }, 50);
        },
        expertAssignmentInviteInvitation(emailType) {
            if (this.$store.state.expert.selectedExpertIds.length === 0) {
                alert("Please select at least one expert");
                return;
            }
            this.emailType = emailType;
            setTimeout(() => {
                this.$refs.expertAssignmentInviteEmailForm.submit();
            }, 50);
        },
        toggleAll() {
            this.loader = true;
            const state = !this.$store.state.expert.showAll;
            this.$store.commit("expert/setShowAll", state);
            this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page: 1 })
                .then(() => {
                    this.loader = false;
                });
        },
        toggleSelectAllExperts(event) {
            const checked = event.target.checked;
            this.$store.commit("expert/setSelectAllExperts", checked);

            if (checked) {
                const DECLINED_STATUS_ID = 4;
                const allExpertIds = (this.$store.state.expert.usersExpertsObj?.data || [])
                    .filter((user) => {
                        const assignment = (user.expert.assignments || []).find(
                            (a) => Number(a.project_id) === Number(this.project.id)
                        );
                        const notDeclined = assignment && Number(assignment.status_id) !== DECLINED_STATUS_ID;
                        return notDeclined;
                    })
                    .map((user) => Number(user.expert.id));

                this.$store.commit("expert/setSelectedExpertIds", allExpertIds);
                this.$store.commit("expert/setSelectedJobExpIds", []);
            } else {
                this.$store.commit("expert/setSelectedExpertIds", []);
                this.$store.commit("expert/setSelectedJobExpIds", []);
            }
        },
        filterExpertByStatus(status) {
            this.loader = true;

            this.$store.commit("expert/setSelectAllExperts", false);
            this.$store.commit("expert/setAssignmentStatusFilterSelected", status);
            this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id }).then(() => {
                this.loader = false;
            });
        },
        getCloneProjectUrl(projectId, includeExpert = false) {
            const selectedIds = this.selectedExpertIds;
            const url = new URL(`/admin/project/clone/${projectId}`, window.location.origin);

            if (includeExpert && !isEmpty(selectedIds)) {
                url.searchParams.append("selectedCloneIds", this.selectedExpertIdsComputed);
                url.searchParams.append("selectedJobExpIds", this.selectedJobExpIdsComputed);
            }

            return url;
        },
        async showProjectSelectModal() {
            if (this.selectedExpertIdsComputed.length === 0) {
                alert("You have not selected any experts");
                return;
            }
            await this.$store.dispatch("expert/fetchUnsubscribedExpertIds", this.selectedExpertIds);
            if (this.$refs.projectSelectModal) {
                this.$refs.projectSelectModal.show();
            }
        },
        showInvoiceExportModal() {
            this.$refs.invoiceExportModal?.show();
        },
        /**
         * Handle remove expert event from modal
         * Updates the Vuex store by removing the expert from selection
         */
        onRemoveExpertFromModal(expertId) {
            const currentIds = [...this.selectedExpertIds];
            const updatedIds = currentIds.filter((id) => Number(id) !== Number(expertId));
            this.$store.commit("expert/setSelectedExpertIds", updatedIds);
        },
        onMigrationComplete() {
            this.$store.commit("expert/setSelectedExpertIds", []);
            this.$store.commit("expert/setSelectedJobExpIds", []);
            this.$store.commit("expert/setSelectAllExperts", false);
            this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page: 1 });
        },
        onProjectSelectModalClosed() {
            console.log("onProjectSelectModalClosed");
            this.$store.commit("expert/setSelectedExpertIds", []);
            this.$store.commit("expert/setSelectedJobExpIds", []);
            this.$store.commit("expert/setSelectAllExperts", false);
        },
    },
};
</script>
